import React, {useState, useEffect } from 'react';
import {useHistory} from "react-router-dom";
import axios from "axios";
import {toast, ToastContainer} from 'react-toastify';
import { Card, Row, Col, Table, Spinner, Form, Button, Alert } from "react-bootstrap";
import DocViewer, { DocViewerRenderers } from "react-doc-viewer";
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import { Chart as ChartJS, ArcElement, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, LineElement, PointElement } from 'chart.js';

ChartJS.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,   // This is required for rendering points in Line and Scatter charts
  Title,
  Tooltip,
  Legend
);


ChartJS.register(ArcElement, CategoryScale, LinearScale, BarElement, LineElement, Title, Tooltip, Legend);

const Mou = () => {
  
    const [mous, setMous] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize] = useState();
    const [totalPages, setTotalPages] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [selectedFromYear, setSelectedFromYear] = useState("");
    const [selectedToYear, setSelectedToYear] = useState("");
    const [selectedCategory, setSelectedCategory] = useState(""); // New state for category
    const history = useHistory();
    const [mouTypesCount, setMouTypesCount] = useState({});
    const [signingDatesCount, setSigningDatesCount] = useState({});
    const [searchQuery, setSearchQuery] = useState('');  // State for search query
    const [years, setYears] = useState([]);
    const [selectedFromDate, setSelectedFromDate] = useState('');
    const [selectedToDate, setSelectedToDate] = useState('');
    const [statusFilter, setStatusFilter] = useState('');
    const [selectedDocument, setSelectedDocument] = useState(null);


    const handleReset = () => {
        setSelectedFromDate('');
        setSelectedToDate('');
        setSelectedCategory('');
        setSearchQuery('');
        setStatusFilter('');
      };


    const accessLevel = parseInt(sessionStorage.getItem("accessLevel"), 10);



    // Function to open document
  const openDocument = (filename) => {
    if (!filename) {
      alert("No document available!");
      return;
    }
    setSelectedDocument(filename);
  };
    const handleSubmit = (event) => {
        event.preventDefault();
        // Add your filter logic here or any actions you want to take upon form submission
        console.log("Filter from year:", selectedFromYear, "to year:", selectedToYear);
    };

    useEffect(() => {
        const getMousData = async (page) => {
            setLoading(true);
            try {
                const firstfetch=`${process.env.REACT_APP_API_BASE_URL}/api/mous`;
                const response2 = await axios.get(firstfetch);

                const url = `${process.env.REACT_APP_API_BASE_URL}/api/mous?page=${page}&size=${response2.data.page.totalElements}`;
                const response = await axios.get(url);

                localStorage.setItem("mou_total",response2.data.page.totalElements);
    
                // Extract MOU data or default to an empty array
                const allMous = response.data._embedded ? response.data._embedded.mous : [];
                
                // Process each MOU to add expiry information
                const mousWithExpiry = allMous.map((mou) => {
                    const expiryDate = mou.dateOfEnd ? new Date(mou.dateOfEnd) : null;
                    const isExpired = expiryDate ? new Date() > expiryDate : false;
    
                    return { ...mou, expiryDate, isExpired };
                });

               
              
    
                // Update state with processed MOU data
                setMous(mousWithExpiry);
                setTotalPages(response.data.page.totalPages);
                setTotalCount(response.data.page.totalElements);
    
                // Calculate months for signing dates and unique years
                const months = mousWithExpiry.reduce((acc, mou) => {
                    const signDate = new Date(mou.dateOfSign);
                    const monthYear = signDate.toLocaleString('default', { month: 'long' }) + ' ' + signDate.getFullYear();
                    acc[monthYear] = true;  // Use month-year as key
                    return acc;
                }, {});
    
                // Extract unique years from signing dates
                const uniqueYears = [...new Set(mousWithExpiry.map((mou) => new Date(mou.dateOfSign).getFullYear()))];
                setYears(uniqueYears);
                setSigningDatesCount(months);
            } catch (error) {
                console.error("Error fetching MOUs:", error);
                toast.error("Failed to fetch MOUs. Please try again later.");
            } finally {
                setLoading(false);
            }
        };
    
        getMousData(currentPage);
    }, [currentPage, pageSize]);
    
    
    useEffect(() => {
        const getMouTypesCount = () => {
            const counts = mous.reduce((acc, mou) => {
                acc[mou.mou_type] = (acc[mou.mou_type] || 0) + 1;
                return acc;
            }, {});
            setMouTypesCount(counts);
           
        };

        if (mous.length > 0) {
            getMouTypesCount();
        }
    }, [mous]);

    // Filtering logic
const filteredMous = mous.filter(mou => {
  // Date range filtering logic
  const signDate = new Date(mou.dateOfSign).toISOString().split('T')[0]; // Extract the date part (YYYY-MM-DD)
  
  const isInDateRange = (!selectedFromDate || signDate >= selectedFromDate) &&
                        (!selectedToDate || signDate <= selectedToDate);
  
  // Category filtering logic
  const isInCategory = !selectedCategory || mou.mou_type === selectedCategory;
  
  // Search query filter
  const matchesSearchQuery = mou.mouId.toLowerCase().includes(searchQuery.toLowerCase()) || 
                             mou.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
                             mou.ptnOrg.toLowerCase().includes(searchQuery.toLowerCase()) ||
                             mou.mou_type.toLowerCase().includes(searchQuery.toLowerCase());
  
  // Status filter (active/expired)
  const matchesStatusFilter =
      statusFilter === '' || // No filter, show all
      (statusFilter === 'active' && !mou.isExpired) || // Only active items
      (statusFilter === 'expired' && mou.isExpired); // Only expired items

  // Return the combined filter result
  return isInDateRange && isInCategory && matchesSearchQuery && matchesStatusFilter;
});

// Group filtered MOU types for rendering in cards
const mouTypesCountc = filteredMous.reduce((acc, mou) => {
    acc[mou.mou_type] = (acc[mou.mou_type] || 0) + 1;
    return acc;
}, {});

const handleDeleteConfirmation = (mouId) => {
  Swal.fire({
    title: "Are you sure?",
    text: "You won't be able to revert this!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#FFA500",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Yes, delete it!",
  }).then((result) => {
    if (result.isConfirmed) {
      handleDelete(mouId); // Call delete function if confirmed
    }
  });
};
    
// Counting active and expired MOUs
const activeCount = filteredMous.filter(mou => !mou.isExpired).length;
const expiredCount = filteredMous.filter(mou => mou.isExpired).length;
    
    
    
    
    
    const colorsByMouType = {
        'INTERNATIONAL ORGANIZATION': '#E9F40C',  
    'NATIONAL ORGANIZATION': '#1758E9',  
    'INTERNATIONAL INSTITUTUTE': '#29D77C',  
    'NATIONAL INSTITUTUTE': '#D8284E',  
    };
    

  

    const handleDelete = async (mouId) => {
        try {
            await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/mous/${mouId}`);
            setMous(mous.filter(mou => mou.mouId !== mouId)); // Remove the deleted MOU from the state
            Swal.fire("Deleted!", "MOU has been deleted.", "success");
        } catch (error) {
            console.error("Error deleting MOU:", error);
            toast.error("Failed to delete MOU. Please try again later.");
        }
    };
   const handleOpenFile = (filename) => {
    if (!filename) {
        alert("No file path found. Please check the file name.");
        return;
    }
   
     const filePath = `${process.env.REACT_APP_FILE_URL || 'https://ooo-toddler-gifts-pubs.trycloudflare.comloudflare.com'}/uploads/${filename}`;

    // Try opening in a new tab (may not work due to browser security)
    window.open(filePath, "_blank");


};

  
  
   const handleRenew = (mouId,title) => {
    localStorage.setItem("mouid", mouId+' - '+title); // Store MOU ID in localStorage
    window.location.href = "/mou_renewal"; // Navigate to mou_renewal
   };


   
   const handleRenewd = (mouId) => {
    localStorage.setItem("mouidd", mouId); // Store MOU ID in localStorage
    window.location.href = "/mou_renewaldata"; // Navigate to mou_renewal
   };

  
  
    const handleAdd = () => {
        history.push('/AddMou'); // Redirect to a page to add MOU (create form)
    };
    const handleOutcome = () => {
        history.push('/MouOutcome'); // Redirect to a page to add MOU (create form)
    };

    const handleout = () =>{
        history.push('/MouOutcomes');
    }









    const handleEdit = (mouId) => {
        history.push(`/AddMou/${mouId}`);
       // Redirect to the EditMou page with the mouId
    };

    if (loading) {
        return (
            <div className="container" style={{
                position: 'absolute',
                top: '40%',
                left: '50%',
                transform: 'translateX(-50%)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 1,
                width: '100%',
                backgroundColor: 'transparent',
                paddingTop: '20px',
            }}>
                <div style={{ textAlign: 'center', zIndex: 2 }}>
                    <Spinner animation="border" variant="primary" style={{ width: '4rem', height: '4rem' }} />
                    <h4 className="mt-3 text-dark">Loading MOUs...</h4>
                </div>
            </div>
        );
    }
  
    return (
        <div className="p-4">
            <ToastContainer />
            
            {/* Header & Actions */}
            <div className="d-flex justify-content-between align-items-center mb-4 pb-3 border-bottom">
                <h3 className="h4 text-dark font-weight-bold mb-0">MOU Dashboard</h3>
                <div className="d-flex gap-2">
                    <Button variant="primary" className="px-3" onClick={handleAdd}>
                        Add MOU
                    </Button>
                    {sessionStorage.getItem("access_level") !== 'null' && (
                        <Button variant="outline-primary" className="px-3" onClick={handleOutcome}>
                            MOU Outcome
                        </Button>
                    )}
                    <Button variant="outline-secondary" className="px-3" onClick={handleout}>
                        View Outcomes
                    </Button>
                </div>
            </div>

            {/* Metrics Overview Cards */}
            <Row className="mb-4 g-3">
                <Col md={4}>
                    <Card className="shadow-sm border-0 text-center text-white p-3" style={{ backgroundColor: '#007BFF' }}>
                        <Card.Body>
                            <Card.Title className="text-uppercase mb-2" style={{ fontSize: '0.85rem', letterSpacing: '1px', fontWeight: 'bold' }}>Total MOUs</Card.Title>
                            <h2 className="display-6 font-weight-bold mb-0">{totalCount}</h2>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={4}>
                    <Card className="shadow-sm border-0 text-center text-white p-3" style={{ backgroundColor: '#28A745' }}>
                        <Card.Body>
                            <Card.Title className="text-uppercase mb-2" style={{ fontSize: '0.85rem', letterSpacing: '1px', fontWeight: 'bold' }}>Active MOUs</Card.Title>
                            <h2 className="display-6 font-weight-bold mb-0">
                                {statusFilter === 'active' || statusFilter === '' ? activeCount : 0}
                            </h2>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={4}>
                    <Card className="shadow-sm border-0 text-center text-white p-3" style={{ backgroundColor: '#FFC107' }}>
                        <Card.Body>
                            <Card.Title className="text-uppercase mb-2" style={{ fontSize: '0.85rem', letterSpacing: '1px', fontWeight: 'bold' }}>Completed MOUs</Card.Title>
                            <h2 className="display-6 font-weight-bold mb-0">
                                {statusFilter === 'expired' || statusFilter === '' ? expiredCount : 0}
                            </h2>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {/* Main Content Layout */}
            <Row className="align-items-start">
                {/* Left Column: Filters and Category Summary Cards */}
                <Col md={4} className="d-flex flex-column mb-4">
                    <Card className="shadow-sm border-0 mb-4 bg-light">
                        <Card.Body className="p-3">
                            <h5 className="mb-3 font-weight-bold text-dark" style={{ fontSize: '1rem' }}>Filter Options</h5>
                            <Form onSubmit={handleSubmit}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="small text-muted font-weight-bold mb-1">Status Filter</Form.Label>
                                    <Form.Select
                                        value={statusFilter}
                                        onChange={(e) => setStatusFilter(e.target.value)}
                                        size="sm"
                                    >
                                        <option value="">All Statuses</option>
                                        <option value="active">Active</option>
                                        <option value="expired">To be Renewed</option>
                                    </Form.Select>
                                </Form.Group>
                                
                                <Row className="mb-3">
                                    <Col>
                                        <Form.Group>
                                            <Form.Label className="small text-muted font-weight-bold mb-1">From Date</Form.Label>
                                            <Form.Control
                                                type="date"
                                                value={selectedFromDate}
                                                onChange={(e) => setSelectedFromDate(e.target.value)}
                                                size="sm"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label className="small text-muted font-weight-bold mb-1">To Date</Form.Label>
                                            <Form.Control
                                                type="date"
                                                value={selectedToDate}
                                                onChange={(e) => setSelectedToDate(e.target.value)}
                                                size="sm"
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Form.Group className="mb-3">
                                    <Form.Label className="small text-muted font-weight-bold mb-1">Category</Form.Label>
                                    <Form.Select
                                        value={selectedCategory}
                                        onChange={(e) => setSelectedCategory(e.target.value)}
                                        size="sm"
                                    >
                                        <option value="">Select Category</option>
                                        <option value="International organization">International Organization</option>
                                        <option value="National organization">National Organization</option>
                                        <option value="International institute">International Institute</option>
                                        <option value="National institute">National Institute</option>
                                    </Form.Select>
                                </Form.Group>

                                <Button variant="secondary" onClick={handleReset} size="sm" className="w-100 mt-2">
                                    Reset Filters
                                </Button>
                            </Form>
                        </Card.Body>
                    </Card>

                    {/* Category Summary Cards */}
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', width: '100%', justifyContent: 'center' }}>
                        {Object.keys(mouTypesCountc).map((type, index) => {
                            const gradients = [
                                "linear-gradient(45deg, #A8E6CF, #DCEDC1)",
                                "linear-gradient(45deg, #FFB74D, #FFEB8E)",
                                "linear-gradient(45deg, #9B59B6, #D7BDE2)",
                                "linear-gradient(45deg, #F1948A, #FAD7A0)"
                            ];
                            const backgroundGradient = gradients[index % gradients.length];
                            const displayType = type === 'null' || !type ? 'Uncategorized' : type;
                            return (
                                <div key={type} style={{ flex: '1 1 calc(50% - 6px)', minWidth: '130px', boxSizing: 'border-box', marginBottom: '4px' }}>
                                    <Card
                                        className="shadow-sm border-0 h-100"
                                        style={{
                                            background: backgroundGradient,
                                            borderRadius: "8px",
                                            minHeight: "120px"
                                        }}
                                    >
                                        <Card.Body className="p-2 text-center d-flex flex-column justify-content-center align-items-center">
                                            <h6 className="card-title text-dark font-weight-bold mb-2" style={{ fontSize: '0.8rem', wordBreak: 'break-word', fontWeight: '700' }}>
                                                {displayType}
                                            </h6>
                                            <p className="card-text text-dark font-weight-bold mb-0" style={{ fontSize: '1rem', fontWeight: '950' }}>
                                                {mouTypesCount[type]} MOUs
                                            </p>
                                        </Card.Body>
                                    </Card>
                                </div>
                            );
                        })}
                    </div>
                </Col>

                {/* Right Column: Search and Table Section */}
                <Col md={8} className="mb-4">
                    <Card className="shadow-sm border-0">
                        <Card.Body className="p-3">
                            <Form.Control
                                type="text"
                                className="mb-3"
                                placeholder="Search by MOU ID, MOU TYPE or PARTNER ORGANIZATION..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />

                            <div className="table-responsive" style={{ maxHeight: '550px' }}>
                                <Table striped bordered hover className="align-middle mb-0">
                                    <thead className="table-dark" style={{ position: 'sticky', top: 0, zIndex: 10 }}>
                                        <tr>
                                            <th>MOU ID</th>
                                            <th>Organization</th>
                                            <th>Type</th>
                                            <th>Date of Sign</th>
                                            <th>Expiry Date</th>
                                            <th>Status</th>
                                            <th>Actions</th>
                                            <th>View Document</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredMous.map((mou) => (
                                            <tr key={mou.mouId}>
                                                <td className="font-weight-bold">{mou.mouId}</td>
                                                <td>{mou.ptnOrg}</td>
                                                <td className="small">{mou.mou_type}</td>
                                                <td>{new Date(mou.dateOfSign).toLocaleDateString()}</td>
                                                <td>{mou.expiryDate ? new Date(mou.expiryDate).toLocaleDateString() : 'N/A'}</td>
                                                <td>
                                                    {mou.isExpired ? (
                                                        <span className="badge bg-danger">Completed</span>
                                                    ) : (
                                                        <span className="badge bg-success">Active</span>
                                                    )}
                                                </td>
                                                <td>
                                                    <div className="d-flex gap-1 justify-content-center flex-wrap">
                                                        <Button
                                                            variant="primary"
                                                            size="sm"
                                                            onClick={() => handleRenewd(mou.mouId)}
                                                        >
                                                            Details
                                                        </Button>
                                                        <Button
                                                            variant="warning"
                                                            size="sm"
                                                            className="text-white"
                                                            onClick={() => handleEdit(mou.mouId)}
                                                        >
                                                            Edit
                                                        </Button>
                                                        <Button
                                                            variant="danger"
                                                            size="sm"
                                                            onClick={() => handleDeleteConfirmation(mou.mouId)}
                                                        >
                                                            Delete
                                                        </Button>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="d-flex flex-column gap-2 align-items-center text-center">
                                                        <a
                                                            href="#"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                handleOpenFile(mou.document);
                                                            }}
                                                            className="text-primary font-weight-bold"
                                                            style={{ textDecoration: 'underline', cursor: 'pointer' }}
                                                        >
                                                            Link
                                                        </a>
                                                        {mou.isExpired && (
                                                            <Button
                                                                variant="outline-success"
                                                                size="sm"
                                                                onClick={() => handleRenew(mou.mouId, mou.title)}
                                                            >
                                                                Renewalform
                                                            </Button>
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default Mou;
